import { render } from "./SystemSubscriptions.vue?vue&type=template&id=b7c58ae8&scoped=true"
import script from "./SystemSubscriptions.vue?vue&type=script&lang=js"
export * from "./SystemSubscriptions.vue?vue&type=script&lang=js"

import "./SystemSubscriptions.vue?vue&type=style&index=0&id=b7c58ae8&scoped=true&lang=scss"

import exportComponent from "/var/www/html/vg.carvex.ee/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7c58ae8"]])

export default __exports__